export default __webpack_public_path__ + "static/media/Animals16.f83e885c.jpg";